import { Component, OnInit, signal } from '@angular/core';
import { UserBaseModel } from '../../../../security/models/UserBaseModel';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

type LoginNotice = 'session-expired' | 'session-refresh-error' | 'token-validation-error' | null;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  readonly notice = signal<LoginNotice>(null);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.route.queryParamMap.pipe(takeUntilDestroyed()).subscribe(params => {
      const reason = params.get('reason');

      if (reason === 'session-expired' || reason === 'session-refresh-error' || reason === 'token-validation-error') {
        this.notice.set(reason);
      } else if (params.has('checktime')) {
        // Keep old links compatible with the former token-validation redirect.
        this.notice.set('token-validation-error');
      } else {
        this.notice.set(null);
      }
    });
  }

  ngOnInit(): void {
  }

  loggedIn(user: UserBaseModel): void {
    this.router.navigate(['/choose-application']).then(() => {
      console.log(user, 'User logged in');
    });
  }
}
